import React from "react";

import RootWrapper from 'src/libs/preBuild/ApplicationWrapper';

export const wrapPageElement = ({element}) => <RootWrapper>{element}</RootWrapper>;